import React, { useState, useEffect, memo, useCallback, useRef } from "react";
import PT from "prop-types";
import { CommentForm, CommentsWrap, SubmitButton, Preloader } from "./styled";
import Comment from "./Comment";
import PlaneIcon from "_c/icon/Plane";
import { HeartsPreloader } from "_c/preloader";
import { CommentsAPI } from "@/api/comments";

const Comments = memo(({ portfolioId, authUserId, t, ...props }) => {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [input, setInput] = useState("");
  const inputRef = useRef(null);
  useEffect(() => {
    async function foo() {
      if (!portfolioId) return;
      setLoading(true);
      try {
        const { data } = await CommentsAPI.getComments(
          "portfolio",
          portfolioId
        );
        setComments(data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }
    foo();
  }, [portfolioId]);
  const addComment = async (e) => {
    e.preventDefault();
    try {
      setSending(true);
      const comment = await props.addComment(portfolioId, {
        text: input,
      });
      setInput("");
      setComments((comments) => [...comments, comment]);
    } catch (e) {
      console.error(e);
    } finally {
      setSending(false);
    }
  };
  const removeComment = useCallback(
    async (id) => {
      setComments((comments) => comments.filter(({ _id }) => _id !== id));
      await props.removeComment(portfolioId, id);
    },
    [portfolioId]
  );
  const insertNameIntoInput = (name) => {
    if (!authUserId) return;
    setInput(`@${name}, ${input}`);
    inputRef.current.focus();
  };
  return (
    <React.Fragment>
      <CommentsWrap data-scroll-lock-scrollable>
        {loading ? (
          <Preloader size="md" />
        ) : (
          <React.Fragment>
            {comments.map((comment) => (
              <Comment
                t={t}
                isAuth={!!authUserId}
                isOwner={authUserId === comment.author._id}
                onRemove={removeComment}
                key={comment._id}
                comment={comment}
                insertNameIntoInput={insertNameIntoInput}
              />
            ))}
          </React.Fragment>
        )}
      </CommentsWrap>
      <CommentForm onSubmit={addComment}>
        <input
          required
          disabled={!authUserId}
          ref={inputRef}
          type="text"
          value={input}
          onChange={({ target }) => setInput(target.value)}
          placeholder={t("common:comment")}
        />
        <SubmitButton
          title={t("common:submit")}
          disabled={sending}
          type="submit"
        >
          {sending ? (
            <HeartsPreloader style={{ width: "30px" }} />
          ) : (
            <PlaneIcon width="22" color="var(--font-color-emp)" />
          )}
        </SubmitButton>
      </CommentForm>
    </React.Fragment>
  );
});
Comments.propTypes = {
  portfolioId: PT.string,
  authUserId: PT.string,

  t: PT.func.isRequired,
};
export default Comments;
